import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { colors } from '@/constants/colors';
import { TableStore } from '@/pages/Admin/Stores';
import Btn from '../UI/Btn';
import { useUIStore } from '@/store/useUIStore';
import { deleteStore } from '@/api/store';
import { toast } from 'react-toastify';

interface Props<T = unknown> {
   data: {
      data: T;
      msg: string;
      // When set, the user must type this word before Confirm enables —
      // for wipes that are too big for a plain yes/no.
      confirmWord?: string;
   };
   actions?: {
      onConfirm?: (data: T) => void;
      onCancel?: () => void;
   };
}

const Verification = <T,>({ data, actions }: Props<T>) => {
   const { handleClose, handleRefresh } = useUIStore();
   const [isLoading, setIsLoading] = useState(false);
   const [typed, setTyped] = useState('');

   useEffect(() => {
      setIsLoading(false);
      setTyped('');
   }, [data]);

   const confirmLocked = !!data.confirmWord && typed !== data.confirmWord;

   // console.log('msg', data.msg);

   const handleDelete = () => {
      // console.log('data', data);
      // console.log('actions', actions);
      // if(isLoading) return;
      // setIsLoading(true);
      // actions?.onConfirm?.(data.data);
      // if(isLoading) return;
      // setIsLoading(true);
      // deleteStore(data.store._id).then(async (res) => {
      //   console.log('res', res);
      //   setIsLoading(false);
      //   toast.success(res.data.msg, {
      //     position: "top-right",
      //     autoClose: 2500,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //   });
      //  handleClose();
      //  await new Promise(resolve => setTimeout(resolve, 300));
      //  handleRefresh();
      // }).catch((err) => {
      //   console.log('err', err);
      //   setIsLoading(false);
      //   toast.error('Something went wrong', {
      //     position: "top-right",
      //     autoClose: 2500,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //   });
      // })
   };

   const handleConfirm = () => {
      if (isLoading || confirmLocked) return;

      setIsLoading(true);
      actions?.onConfirm?.(data.data);
      // handleClose();
   };

   return (
      <Wrapper>
         <Content>
            <Message>{data.msg}</Message>
            {data.confirmWord && (
               <ConfirmInputWrap>
                  <ConfirmHint>
                     Type <strong>{data.confirmWord}</strong> to confirm:
                  </ConfirmHint>
                  <ConfirmInput
                     value={typed}
                     onChange={(e) => setTyped(e.target.value)}
                     placeholder={data.confirmWord}
                     autoFocus
                  />
               </ConfirmInputWrap>
            )}
         </Content>
         <BtnWrapper>
            <div onClick={handleClose}>
               <Btn
                  title="Cancel"
                  type="outline"
                  bgcolor={colors.GRAY10}
                  textcolor={colors.GRAY1}
                  size="small"
               />
            </div>
            <div onClick={handleConfirm}>
               <Btn
                  title="Confirm"
                  type={isLoading || confirmLocked ? 'disabled' : 'normal'}
                  bgcolor={isLoading || confirmLocked ? colors.GRAY10 : colors.RED}
                  textcolor={isLoading || confirmLocked ? colors.GRAY8 : 'white'}
                  size="small"
                  hasIcon={isLoading}
                  icon="loader"
                  iconPosition="right"
               />
            </div>
         </BtnWrapper>
      </Wrapper>
   );
};

const Wrapper = styled.div`
   /* width:100% so message + buttons fill the outer modal (min-width: 500px
      in _Placeholder.tsx). Previously max-width: 350px left an empty
      strip on the right — the "spacious right" feel surfaced 2026-05-25. */
   width: 100%;
   height: 100%;
`;

// style this component
const Content = styled.div`
   width: 100%;
   height: 100%;
   padding: 1rem;
`;

const BtnWrapper = styled.div`
   width: 100%;
   height: 100%;
   display: flex;
   justify-content: flex-end;
   align-items: center;
   gap: 1rem;
`;

const Message = styled.p`
   font-size: 14px;
   font-weight: 500;
   color: ${colors.GRAY3};
`;

const ConfirmInputWrap = styled.div`
   margin-top: 1rem;
   display: flex;
   flex-direction: column;
   gap: 0.5rem;
`;

const ConfirmHint = styled.p`
   font-size: 13px;
   color: ${colors.GRAY3};

   strong {
      color: ${colors.RED};
      letter-spacing: 1px;
   }
`;

const ConfirmInput = styled.input`
   width: 100%;
   padding: 0.5rem 0.75rem;
   font-size: 14px;
   border: 1px solid ${colors.GRAY9};
   border-radius: 6px;
   outline: none;

   &:focus {
      border-color: ${colors.RED};
   }
`;

export default Verification;
